var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "设置坑位",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex a-center mb-15 mt-20",
              staticStyle: { "justify-content": "center" },
            },
            [
              _c("div", { staticClass: "mr10" }, [
                _vm._v(_vm._s(_vm.detailInfo.name)),
              ]),
              _c(
                "div",
                { staticStyle: { width: "200px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    on: {
                      blur: () =>
                        (_vm.detailInfo.slot =
                          _vm.detailInfo.slot == 0
                            ? ""
                            : _vm.tool.filterUnNumber(_vm.detailInfo.slot)),
                    },
                    model: {
                      value: _vm.detailInfo.slot,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailInfo, "slot", $$v)
                      },
                      expression: "detailInfo.slot",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }